export let Project = {
  RevenueCat: {
    apple: 'appl_',
    google: 'goog_',
  },

  api: 'https://staging-api.hoxtonmix.com/api/v3/',
  apiAuth: '',
  cognito: {
    region: 'eu-west-2',
    userPoolId: 'eu-west-2_3dro99y9o',
    userPoolWebClientId: '7pr4c93i9l470rubfodpbdglm2',
  },
  companyAPI: 'https://staging-api.hoxtonmix.com/api/v3/',
  currency: 'GBP',
  customerPortalURL: 'https://staging-account.hoxtonmix.com',
  debug: false,
  defaultLocation: {
    'address_line_1': '66 Paul Street',
    'address_line_2': null,
    'city': 'London',
    'country': 'GB',
    'id': 1,
    'name': '66 Paul Street',
    'postal_code': 'EC2A 4NA',
    'state': 'England',
  },
  flagsmith: 'Hc2gntqJyXDZmiBn4r2yjL',
  ga: '',
  headers: {},
  locale: 'en-gb',
  logs: {
    API: false,
    COGNITO: false,
    DATA: false,
    DISPATCHER: false,
    EVENTS: true,
    PUSH_NOTIFICATIONS: false,
    SERVER: false,
    STORAGE: false,
    STORE: false,
  },
  loqate: 'PR28-BF96-PB24-GY46',
  sentry:
    'https://2434988c9e0d3757db35049c7cd6c8fb@o31090.ingest.us.sentry.io/4509716992425984',
  sentryEnvironment: 'staging',
}

export function setProject(newProject) {
  Project = newProject
}
